module.exports = __webpack_public_path__ + "static/img/Lachie-Galvin.e057bd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie-Galvin.jpg
// module id = L7/y
// module chunks = 0